module.exports = __webpack_public_path__ + "img/online.7df0d257.svg";